import * as PropTypes from 'prop-types';
import * as React from 'react';

class SocialLink extends React.Component {
  static propTypes = {
    type: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    icon: PropTypes.string,
  };

  icon = () => this.props.icon || this.props.type;

  render() {
    return (
      <a href={this.props.link} target="_blank" rel="noopener noreferrer">
        <span className={`share-${this.props.type} no-icon-bg`}>
          <span className={`fa fa-${this.icon()}`} />
        </span>
      </a>
    );
  }
}

export default SocialLink;



// WEBPACK FOOTER //
// ./javascripts/components/shared/social_link.jsx